import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  getCurrentPosition(): Observable<any> {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position.coords);
            observer.complete();
          },
          (error) => {
            observer.next(error);
            observer.complete();
            // observer.error(error);
          }
        );
      } else {
        observer.next({error:'Geolocation is not available in this browser.'});
        observer.complete();
        // observer.error('Geolocation is not available in this browser.');
      }
    });
  }
}
